<template>
  <!-- 添加成员弹框 -->
  <div style="font-family: SimHei;">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="170">
      <FormItem label="姓名：" prop="name" class="bumenModal-item">
        <Input v-model="formValidate.name" placeholder="请输入姓名" />
      </FormItem>
      <FormItem label="部门：" prop="department" class="bumenModal-item">
        <Input search enter-button="选择" v-model="formValidate.department" @on-search="selectIshow" readonly placeholder="请选择部门" />
      </FormItem>
      <Modal v-model="bumenModal1" width="700px" footer-hide title="选择部门">
        <Transfer ref="Transfer" :titleObj="titleObj" @setbumenModal="setbumenModal" @setData="setData"></Transfer>
      </Modal>
      <FormItem label="职位：" prop="position" class="bumenModal-item">
        <Input v-model="formValidate.position" placeholder="请输入职位" />
      </FormItem>
      <FormItem label="手机：" prop="tel" class="bumenModal-item">
        <Input v-model="formValidate.tel" placeholder="请输入手机" :maxlength="11" />
      </FormItem>
      <div class="zhu">注：登录名为 “手机号”，初始密码为 “手机号后6位”。</div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="handleReset('formValidate')">取消</Button>
        <Button class="btn sure" type="success" ghost @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Form>
  </div>
</template>
<script>
import Transfer from './transfer'
export default {
  name: 'addmember',
  data () {
    return {
      formValidate: {
        name: '',
        department: '',
        position: '',
        tel: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        department: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ],
        position: [
          { required: true, message: '请输入职位', trigger: 'change' }
        ],
        tel: [
          { required: true, message: '请输入手机', trigger: 'change' }
        ],
      },//修改部门提示语和必填校验
      bumenModal1: false,
      titleObj: {},//存储树形信息
      rightListItem: {},//存储传过来已选得选项
      parentobj: {},//传过来的父级
    }
  },
  methods: {
    gettitleobj (item, formValidate) {//获取点击树形传过来得值和上级部门名字id
      this.rightListItem.id = formValidate.formValidate.benid;
      this.rightListItem.structureName = formValidate.formValidate.benname;
      this.parentobj.structureName = formValidate.formValidate.city
      this.parentobj.id = formValidate.formValidate.parentId;
      this.titleObj = item;//树形信息
      this.formValidate = {
        name: '',
        department: this.rightListItem.structureName,
        position: '',
        tel: ''
      }
    },
    selectIshow () {//控制显示部门
      this.bumenModal1 = true;
      this.$refs.Transfer.getTitleone(this.titleObj, this.parentobj, this.rightListItem);//传点击得树形信息 点击的树形 和父级的树形
    },
    setData (res) {//transfer子组件传来选择后得内容
      this.formValidate.department = res.structureName;
      this.rightListItem = res;
    },
    setbumenModal (res) { //子组件传来弹框关闭
      this.bumenModal1 = res;
    },
    handleSubmit (name) { //添加成员 确定校验
      this.$refs[name].validate((valid) => {
        if (valid) {
          let params = {
            formValidate: this.formValidate,
            rightListItem: this.rightListItem
          }
          this.$emit("setMemberShow", params)

        }
      })
    },
    handleReset (name) {//添加成员 取消
      this.$refs[name].resetFields();
      this.$emit("setMemberShow", false)
    },
  },
  components: {
    Transfer,
  }
}
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.bumenModal-item {
  margin-bottom: 20px;
}
.zhu {
  width: 100%;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/tan/addmember.vue